/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AppRouteImport } from './routes/_app'
import { Route as ForgotPasswordRouteImport } from './routes/forgot-password'
import { Route as LoginRouteImport } from './routes/login'
import { Route as AppIndexRouteImport } from './routes/_app/index'
import { Route as App403RouteImport } from './routes/_app/403'
import { Route as AppSettingsRouteImport } from './routes/_app/_settings'
import { Route as AppControlRouteImport } from './routes/_app/control'
import { Route as AppDirectoryRouteImport } from './routes/_app/directory'
import { Route as AppDocumentsRouteImport } from './routes/_app/documents'
import { Route as AppInboxRouteImport } from './routes/_app/inbox'
import { Route as AppMyRouteImport } from './routes/_app/my'
import { Route as AppSearchRouteImport } from './routes/_app/search'
import { Route as AppTeamRouteImport } from './routes/_app/team'
import { Route as EnterTokenRouteImport } from './routes/enter.$token'
import { Route as HelpAssigneeRouteImport } from './routes/help.assignee'
import { Route as InviteTokenRouteImport } from './routes/invite.$token'
import { Route as AppSettingsAgentKeysRouteImport } from './routes/_app/_settings/agent-keys'
import { Route as AppSettingsAuditRouteImport } from './routes/_app/_settings/audit'
import { Route as AppSettingsProfileRouteImport } from './routes/_app/_settings/profile'
import { Route as AppSettingsRightsRouteImport } from './routes/_app/_settings/rights'
import { Route as AppSettingsSubstitutionsRouteImport } from './routes/_app/_settings/substitutions'
import { Route as AppSettingsSupportAccessRouteImport } from './routes/_app/_settings/support-access'
import { Route as AppSettingsUsersRouteImport } from './routes/_app/_settings/users'
import { Route as AppOpsAlertsRouteImport } from './routes/_app/ops.alerts'
import { Route as AppOpsBackupsRouteImport } from './routes/_app/ops.backups'
import { Route as AppOpsJobsRouteImport } from './routes/_app/ops.jobs'
import { Route as AppOpsLogRouteImport } from './routes/_app/ops.log'
import { Route as AppProtocolsIdRouteImport } from './routes/_app/protocols.$id'
import { Route as AppSettingsAuditExportsRouteImport } from './routes/_app/_settings/audit_.exports'
import { Route as AppSettingsOpsDeploymentsRouteImport } from './routes/_app/_settings/ops.deployments'
import { Route as AppSettingsOpsStatusRouteImport } from './routes/_app/_settings/ops.status'
import { Route as AppSettingsSettingsIndexRouteImport } from './routes/_app/_settings/settings.index'
import { Route as AppSettingsSettingsCompanyRouteImport } from './routes/_app/_settings/settings.company'
import { Route as AppSettingsSettingsDirectoryRouteImport } from './routes/_app/_settings/settings.directory'
import { Route as AppSettingsSettingsLettersRouteImport } from './routes/_app/_settings/settings.letters'
import { Route as AppSettingsSettingsMailRouteImport } from './routes/_app/_settings/settings.mail'
import { Route as AppSettingsSettingsMailingRouteImport } from './routes/_app/_settings/settings.mailing'
import { Route as AppSettingsSettingsPasswordRouteImport } from './routes/_app/_settings/settings.password'
import { Route as AppSettingsSettingsProtocolsRouteImport } from './routes/_app/_settings/settings.protocols'
import { Route as AppSettingsSettingsSessionsRouteImport } from './routes/_app/_settings/settings.sessions'
import { Route as AppSettingsSettingsShortcutsRouteImport } from './routes/_app/_settings/settings.shortcuts'
import { Route as AppSettingsSettingsViewRouteImport } from './routes/_app/_settings/settings.view'
import { Route as AppSettingsUsersIdRouteImport } from './routes/_app/_settings/users.$id'
import { Route as AppSettingsSettingsProtocolsNewRouteImport } from './routes/_app/_settings/settings.protocols_.new'

const AppRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const ForgotPasswordRoute = ForgotPasswordRouteImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AppIndexRoute = AppIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRoute,
} as any)
const App403Route = App403RouteImport.update({
  id: '/403',
  path: '/403',
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsRoute = AppSettingsRouteImport.update({
  id: '/_settings',
  getParentRoute: () => AppRoute,
} as any)
const AppControlRoute = AppControlRouteImport.update({
  id: '/control',
  path: '/control',
  getParentRoute: () => AppRoute,
} as any)
const AppDirectoryRoute = AppDirectoryRouteImport.update({
  id: '/directory',
  path: '/directory',
  getParentRoute: () => AppRoute,
} as any)
const AppDocumentsRoute = AppDocumentsRouteImport.update({
  id: '/documents',
  path: '/documents',
  getParentRoute: () => AppRoute,
} as any)
const AppInboxRoute = AppInboxRouteImport.update({
  id: '/inbox',
  path: '/inbox',
  getParentRoute: () => AppRoute,
} as any)
const AppMyRoute = AppMyRouteImport.update({
  id: '/my',
  path: '/my',
  getParentRoute: () => AppRoute,
} as any)
const AppSearchRoute = AppSearchRouteImport.update({
  id: '/search',
  path: '/search',
  getParentRoute: () => AppRoute,
} as any)
const AppTeamRoute = AppTeamRouteImport.update({
  id: '/team',
  path: '/team',
  getParentRoute: () => AppRoute,
} as any)
const EnterTokenRoute = EnterTokenRouteImport.update({
  id: '/enter/$token',
  path: '/enter/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const HelpAssigneeRoute = HelpAssigneeRouteImport.update({
  id: '/help/assignee',
  path: '/help/assignee',
  getParentRoute: () => rootRouteImport,
} as any)
const InviteTokenRoute = InviteTokenRouteImport.update({
  id: '/invite/$token',
  path: '/invite/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const AppSettingsAgentKeysRoute = AppSettingsAgentKeysRouteImport.update({
  id: '/agent-keys',
  path: '/agent-keys',
  getParentRoute: () => AppSettingsRoute,
} as any)
const AppSettingsAuditRoute = AppSettingsAuditRouteImport.update({
  id: '/audit',
  path: '/audit',
  getParentRoute: () => AppSettingsRoute,
} as any)
const AppSettingsProfileRoute = AppSettingsProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => AppSettingsRoute,
} as any)
const AppSettingsRightsRoute = AppSettingsRightsRouteImport.update({
  id: '/rights',
  path: '/rights',
  getParentRoute: () => AppSettingsRoute,
} as any)
const AppSettingsSubstitutionsRoute =
  AppSettingsSubstitutionsRouteImport.update({
    id: '/substitutions',
    path: '/substitutions',
    getParentRoute: () => AppSettingsRoute,
  } as any)
const AppSettingsSupportAccessRoute =
  AppSettingsSupportAccessRouteImport.update({
    id: '/support-access',
    path: '/support-access',
    getParentRoute: () => AppSettingsRoute,
  } as any)
const AppSettingsUsersRoute = AppSettingsUsersRouteImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => AppSettingsRoute,
} as any)
const AppOpsAlertsRoute = AppOpsAlertsRouteImport.update({
  id: '/ops/alerts',
  path: '/ops/alerts',
  getParentRoute: () => AppRoute,
} as any)
const AppOpsBackupsRoute = AppOpsBackupsRouteImport.update({
  id: '/ops/backups',
  path: '/ops/backups',
  getParentRoute: () => AppRoute,
} as any)
const AppOpsJobsRoute = AppOpsJobsRouteImport.update({
  id: '/ops/jobs',
  path: '/ops/jobs',
  getParentRoute: () => AppRoute,
} as any)
const AppOpsLogRoute = AppOpsLogRouteImport.update({
  id: '/ops/log',
  path: '/ops/log',
  getParentRoute: () => AppRoute,
} as any)
const AppProtocolsIdRoute = AppProtocolsIdRouteImport.update({
  id: '/protocols/$id',
  path: '/protocols/$id',
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsAuditExportsRoute = AppSettingsAuditExportsRouteImport.update({
  id: '/audit_/exports',
  path: '/audit/exports',
  getParentRoute: () => AppSettingsRoute,
} as any)
const AppSettingsOpsDeploymentsRoute =
  AppSettingsOpsDeploymentsRouteImport.update({
    id: '/ops/deployments',
    path: '/ops/deployments',
    getParentRoute: () => AppSettingsRoute,
  } as any)
const AppSettingsOpsStatusRoute = AppSettingsOpsStatusRouteImport.update({
  id: '/ops/status',
  path: '/ops/status',
  getParentRoute: () => AppSettingsRoute,
} as any)
const AppSettingsSettingsIndexRoute =
  AppSettingsSettingsIndexRouteImport.update({
    id: '/settings/',
    path: '/settings/',
    getParentRoute: () => AppSettingsRoute,
  } as any)
const AppSettingsSettingsCompanyRoute =
  AppSettingsSettingsCompanyRouteImport.update({
    id: '/settings/company',
    path: '/settings/company',
    getParentRoute: () => AppSettingsRoute,
  } as any)
const AppSettingsSettingsDirectoryRoute =
  AppSettingsSettingsDirectoryRouteImport.update({
    id: '/settings/directory',
    path: '/settings/directory',
    getParentRoute: () => AppSettingsRoute,
  } as any)
const AppSettingsSettingsLettersRoute =
  AppSettingsSettingsLettersRouteImport.update({
    id: '/settings/letters',
    path: '/settings/letters',
    getParentRoute: () => AppSettingsRoute,
  } as any)
const AppSettingsSettingsMailRoute = AppSettingsSettingsMailRouteImport.update({
  id: '/settings/mail',
  path: '/settings/mail',
  getParentRoute: () => AppSettingsRoute,
} as any)
const AppSettingsSettingsMailingRoute =
  AppSettingsSettingsMailingRouteImport.update({
    id: '/settings/mailing',
    path: '/settings/mailing',
    getParentRoute: () => AppSettingsRoute,
  } as any)
const AppSettingsSettingsPasswordRoute =
  AppSettingsSettingsPasswordRouteImport.update({
    id: '/settings/password',
    path: '/settings/password',
    getParentRoute: () => AppSettingsRoute,
  } as any)
const AppSettingsSettingsProtocolsRoute =
  AppSettingsSettingsProtocolsRouteImport.update({
    id: '/settings/protocols',
    path: '/settings/protocols',
    getParentRoute: () => AppSettingsRoute,
  } as any)
const AppSettingsSettingsSessionsRoute =
  AppSettingsSettingsSessionsRouteImport.update({
    id: '/settings/sessions',
    path: '/settings/sessions',
    getParentRoute: () => AppSettingsRoute,
  } as any)
const AppSettingsSettingsShortcutsRoute =
  AppSettingsSettingsShortcutsRouteImport.update({
    id: '/settings/shortcuts',
    path: '/settings/shortcuts',
    getParentRoute: () => AppSettingsRoute,
  } as any)
const AppSettingsSettingsViewRoute = AppSettingsSettingsViewRouteImport.update({
  id: '/settings/view',
  path: '/settings/view',
  getParentRoute: () => AppSettingsRoute,
} as any)
const AppSettingsUsersIdRoute = AppSettingsUsersIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => AppSettingsUsersRoute,
} as any)
const AppSettingsSettingsProtocolsNewRoute =
  AppSettingsSettingsProtocolsNewRouteImport.update({
    id: '/settings/protocols_/new',
    path: '/settings/protocols/new',
    getParentRoute: () => AppSettingsRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof AppIndexRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/403': typeof App403Route
  '/control': typeof AppControlRoute
  '/directory': typeof AppDirectoryRoute
  '/documents': typeof AppDocumentsRoute
  '/inbox': typeof AppInboxRoute
  '/my': typeof AppMyRoute
  '/search': typeof AppSearchRoute
  '/team': typeof AppTeamRoute
  '/enter/$token': typeof EnterTokenRoute
  '/help/assignee': typeof HelpAssigneeRoute
  '/invite/$token': typeof InviteTokenRoute
  '/agent-keys': typeof AppSettingsAgentKeysRoute
  '/audit': typeof AppSettingsAuditRoute
  '/profile': typeof AppSettingsProfileRoute
  '/rights': typeof AppSettingsRightsRoute
  '/substitutions': typeof AppSettingsSubstitutionsRoute
  '/support-access': typeof AppSettingsSupportAccessRoute
  '/users': typeof AppSettingsUsersRouteWithChildren
  '/ops/alerts': typeof AppOpsAlertsRoute
  '/ops/backups': typeof AppOpsBackupsRoute
  '/ops/jobs': typeof AppOpsJobsRoute
  '/ops/log': typeof AppOpsLogRoute
  '/protocols/$id': typeof AppProtocolsIdRoute
  '/audit/exports': typeof AppSettingsAuditExportsRoute
  '/ops/deployments': typeof AppSettingsOpsDeploymentsRoute
  '/ops/status': typeof AppSettingsOpsStatusRoute
  '/settings/company': typeof AppSettingsSettingsCompanyRoute
  '/settings/directory': typeof AppSettingsSettingsDirectoryRoute
  '/settings/letters': typeof AppSettingsSettingsLettersRoute
  '/settings/mail': typeof AppSettingsSettingsMailRoute
  '/settings/mailing': typeof AppSettingsSettingsMailingRoute
  '/settings/password': typeof AppSettingsSettingsPasswordRoute
  '/settings/protocols': typeof AppSettingsSettingsProtocolsRoute
  '/settings/sessions': typeof AppSettingsSettingsSessionsRoute
  '/settings/shortcuts': typeof AppSettingsSettingsShortcutsRoute
  '/settings/view': typeof AppSettingsSettingsViewRoute
  '/users/$id': typeof AppSettingsUsersIdRoute
  '/settings/': typeof AppSettingsSettingsIndexRoute
  '/settings/protocols/new': typeof AppSettingsSettingsProtocolsNewRoute
}
export interface FileRoutesByTo {
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/403': typeof App403Route
  '/': typeof AppIndexRoute
  '/control': typeof AppControlRoute
  '/directory': typeof AppDirectoryRoute
  '/documents': typeof AppDocumentsRoute
  '/inbox': typeof AppInboxRoute
  '/my': typeof AppMyRoute
  '/search': typeof AppSearchRoute
  '/team': typeof AppTeamRoute
  '/enter/$token': typeof EnterTokenRoute
  '/help/assignee': typeof HelpAssigneeRoute
  '/invite/$token': typeof InviteTokenRoute
  '/agent-keys': typeof AppSettingsAgentKeysRoute
  '/audit': typeof AppSettingsAuditRoute
  '/profile': typeof AppSettingsProfileRoute
  '/rights': typeof AppSettingsRightsRoute
  '/substitutions': typeof AppSettingsSubstitutionsRoute
  '/support-access': typeof AppSettingsSupportAccessRoute
  '/users': typeof AppSettingsUsersRouteWithChildren
  '/ops/alerts': typeof AppOpsAlertsRoute
  '/ops/backups': typeof AppOpsBackupsRoute
  '/ops/jobs': typeof AppOpsJobsRoute
  '/ops/log': typeof AppOpsLogRoute
  '/protocols/$id': typeof AppProtocolsIdRoute
  '/audit/exports': typeof AppSettingsAuditExportsRoute
  '/ops/deployments': typeof AppSettingsOpsDeploymentsRoute
  '/ops/status': typeof AppSettingsOpsStatusRoute
  '/settings/company': typeof AppSettingsSettingsCompanyRoute
  '/settings/directory': typeof AppSettingsSettingsDirectoryRoute
  '/settings/letters': typeof AppSettingsSettingsLettersRoute
  '/settings/mail': typeof AppSettingsSettingsMailRoute
  '/settings/mailing': typeof AppSettingsSettingsMailingRoute
  '/settings/password': typeof AppSettingsSettingsPasswordRoute
  '/settings/protocols': typeof AppSettingsSettingsProtocolsRoute
  '/settings/sessions': typeof AppSettingsSettingsSessionsRoute
  '/settings/shortcuts': typeof AppSettingsSettingsShortcutsRoute
  '/settings/view': typeof AppSettingsSettingsViewRoute
  '/users/$id': typeof AppSettingsUsersIdRoute
  '/settings': typeof AppSettingsSettingsIndexRoute
  '/settings/protocols/new': typeof AppSettingsSettingsProtocolsNewRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_app': typeof AppRouteWithChildren
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/_app/403': typeof App403Route
  '/_app/_settings': typeof AppSettingsRouteWithChildren
  '/_app/control': typeof AppControlRoute
  '/_app/directory': typeof AppDirectoryRoute
  '/_app/documents': typeof AppDocumentsRoute
  '/_app/inbox': typeof AppInboxRoute
  '/_app/my': typeof AppMyRoute
  '/_app/search': typeof AppSearchRoute
  '/_app/team': typeof AppTeamRoute
  '/enter/$token': typeof EnterTokenRoute
  '/help/assignee': typeof HelpAssigneeRoute
  '/invite/$token': typeof InviteTokenRoute
  '/_app/': typeof AppIndexRoute
  '/_app/_settings/agent-keys': typeof AppSettingsAgentKeysRoute
  '/_app/_settings/audit': typeof AppSettingsAuditRoute
  '/_app/_settings/profile': typeof AppSettingsProfileRoute
  '/_app/_settings/rights': typeof AppSettingsRightsRoute
  '/_app/_settings/substitutions': typeof AppSettingsSubstitutionsRoute
  '/_app/_settings/support-access': typeof AppSettingsSupportAccessRoute
  '/_app/_settings/users': typeof AppSettingsUsersRouteWithChildren
  '/_app/ops/alerts': typeof AppOpsAlertsRoute
  '/_app/ops/backups': typeof AppOpsBackupsRoute
  '/_app/ops/jobs': typeof AppOpsJobsRoute
  '/_app/ops/log': typeof AppOpsLogRoute
  '/_app/protocols/$id': typeof AppProtocolsIdRoute
  '/_app/_settings/audit_/exports': typeof AppSettingsAuditExportsRoute
  '/_app/_settings/ops/deployments': typeof AppSettingsOpsDeploymentsRoute
  '/_app/_settings/ops/status': typeof AppSettingsOpsStatusRoute
  '/_app/_settings/settings/company': typeof AppSettingsSettingsCompanyRoute
  '/_app/_settings/settings/directory': typeof AppSettingsSettingsDirectoryRoute
  '/_app/_settings/settings/letters': typeof AppSettingsSettingsLettersRoute
  '/_app/_settings/settings/mail': typeof AppSettingsSettingsMailRoute
  '/_app/_settings/settings/mailing': typeof AppSettingsSettingsMailingRoute
  '/_app/_settings/settings/password': typeof AppSettingsSettingsPasswordRoute
  '/_app/_settings/settings/protocols': typeof AppSettingsSettingsProtocolsRoute
  '/_app/_settings/settings/sessions': typeof AppSettingsSettingsSessionsRoute
  '/_app/_settings/settings/shortcuts': typeof AppSettingsSettingsShortcutsRoute
  '/_app/_settings/settings/view': typeof AppSettingsSettingsViewRoute
  '/_app/_settings/users/$id': typeof AppSettingsUsersIdRoute
  '/_app/_settings/settings/': typeof AppSettingsSettingsIndexRoute
  '/_app/_settings/settings/protocols_/new': typeof AppSettingsSettingsProtocolsNewRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/forgot-password'
    | '/login'
    | '/403'
    | '/control'
    | '/directory'
    | '/documents'
    | '/inbox'
    | '/my'
    | '/search'
    | '/team'
    | '/enter/$token'
    | '/help/assignee'
    | '/invite/$token'
    | '/agent-keys'
    | '/audit'
    | '/profile'
    | '/rights'
    | '/substitutions'
    | '/support-access'
    | '/users'
    | '/ops/alerts'
    | '/ops/backups'
    | '/ops/jobs'
    | '/ops/log'
    | '/protocols/$id'
    | '/audit/exports'
    | '/ops/deployments'
    | '/ops/status'
    | '/settings/company'
    | '/settings/directory'
    | '/settings/letters'
    | '/settings/mail'
    | '/settings/mailing'
    | '/settings/password'
    | '/settings/protocols'
    | '/settings/sessions'
    | '/settings/shortcuts'
    | '/settings/view'
    | '/users/$id'
    | '/settings/'
    | '/settings/protocols/new'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/forgot-password'
    | '/login'
    | '/403'
    | '/'
    | '/control'
    | '/directory'
    | '/documents'
    | '/inbox'
    | '/my'
    | '/search'
    | '/team'
    | '/enter/$token'
    | '/help/assignee'
    | '/invite/$token'
    | '/agent-keys'
    | '/audit'
    | '/profile'
    | '/rights'
    | '/substitutions'
    | '/support-access'
    | '/users'
    | '/ops/alerts'
    | '/ops/backups'
    | '/ops/jobs'
    | '/ops/log'
    | '/protocols/$id'
    | '/audit/exports'
    | '/ops/deployments'
    | '/ops/status'
    | '/settings/company'
    | '/settings/directory'
    | '/settings/letters'
    | '/settings/mail'
    | '/settings/mailing'
    | '/settings/password'
    | '/settings/protocols'
    | '/settings/sessions'
    | '/settings/shortcuts'
    | '/settings/view'
    | '/users/$id'
    | '/settings'
    | '/settings/protocols/new'
  id:
    | '__root__'
    | '/_app'
    | '/forgot-password'
    | '/login'
    | '/_app/403'
    | '/_app/_settings'
    | '/_app/control'
    | '/_app/directory'
    | '/_app/documents'
    | '/_app/inbox'
    | '/_app/my'
    | '/_app/search'
    | '/_app/team'
    | '/enter/$token'
    | '/help/assignee'
    | '/invite/$token'
    | '/_app/'
    | '/_app/_settings/agent-keys'
    | '/_app/_settings/audit'
    | '/_app/_settings/profile'
    | '/_app/_settings/rights'
    | '/_app/_settings/substitutions'
    | '/_app/_settings/support-access'
    | '/_app/_settings/users'
    | '/_app/ops/alerts'
    | '/_app/ops/backups'
    | '/_app/ops/jobs'
    | '/_app/ops/log'
    | '/_app/protocols/$id'
    | '/_app/_settings/audit_/exports'
    | '/_app/_settings/ops/deployments'
    | '/_app/_settings/ops/status'
    | '/_app/_settings/settings/company'
    | '/_app/_settings/settings/directory'
    | '/_app/_settings/settings/letters'
    | '/_app/_settings/settings/mail'
    | '/_app/_settings/settings/mailing'
    | '/_app/_settings/settings/password'
    | '/_app/_settings/settings/protocols'
    | '/_app/_settings/settings/sessions'
    | '/_app/_settings/settings/shortcuts'
    | '/_app/_settings/settings/view'
    | '/_app/_settings/users/$id'
    | '/_app/_settings/settings/'
    | '/_app/_settings/settings/protocols_/new'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AppRoute: typeof AppRouteWithChildren
  ForgotPasswordRoute: typeof ForgotPasswordRoute
  LoginRoute: typeof LoginRoute
  EnterTokenRoute: typeof EnterTokenRoute
  HelpAssigneeRoute: typeof HelpAssigneeRoute
  InviteTokenRoute: typeof InviteTokenRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/forgot-password': {
      id: '/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof ForgotPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/': {
      id: '/_app/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AppIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/403': {
      id: '/_app/403'
      path: '/403'
      fullPath: '/403'
      preLoaderRoute: typeof App403RouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/_settings': {
      id: '/_app/_settings'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppSettingsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/control': {
      id: '/_app/control'
      path: '/control'
      fullPath: '/control'
      preLoaderRoute: typeof AppControlRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/directory': {
      id: '/_app/directory'
      path: '/directory'
      fullPath: '/directory'
      preLoaderRoute: typeof AppDirectoryRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/documents': {
      id: '/_app/documents'
      path: '/documents'
      fullPath: '/documents'
      preLoaderRoute: typeof AppDocumentsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/inbox': {
      id: '/_app/inbox'
      path: '/inbox'
      fullPath: '/inbox'
      preLoaderRoute: typeof AppInboxRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/my': {
      id: '/_app/my'
      path: '/my'
      fullPath: '/my'
      preLoaderRoute: typeof AppMyRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/search': {
      id: '/_app/search'
      path: '/search'
      fullPath: '/search'
      preLoaderRoute: typeof AppSearchRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/team': {
      id: '/_app/team'
      path: '/team'
      fullPath: '/team'
      preLoaderRoute: typeof AppTeamRouteImport
      parentRoute: typeof AppRoute
    }
    '/enter/$token': {
      id: '/enter/$token'
      path: '/enter/$token'
      fullPath: '/enter/$token'
      preLoaderRoute: typeof EnterTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/help/assignee': {
      id: '/help/assignee'
      path: '/help/assignee'
      fullPath: '/help/assignee'
      preLoaderRoute: typeof HelpAssigneeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/invite/$token': {
      id: '/invite/$token'
      path: '/invite/$token'
      fullPath: '/invite/$token'
      preLoaderRoute: typeof InviteTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/_settings/agent-keys': {
      id: '/_app/_settings/agent-keys'
      path: '/agent-keys'
      fullPath: '/agent-keys'
      preLoaderRoute: typeof AppSettingsAgentKeysRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/_settings/audit': {
      id: '/_app/_settings/audit'
      path: '/audit'
      fullPath: '/audit'
      preLoaderRoute: typeof AppSettingsAuditRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/_settings/profile': {
      id: '/_app/_settings/profile'
      path: '/profile'
      fullPath: '/profile'
      preLoaderRoute: typeof AppSettingsProfileRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/_settings/rights': {
      id: '/_app/_settings/rights'
      path: '/rights'
      fullPath: '/rights'
      preLoaderRoute: typeof AppSettingsRightsRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/_settings/substitutions': {
      id: '/_app/_settings/substitutions'
      path: '/substitutions'
      fullPath: '/substitutions'
      preLoaderRoute: typeof AppSettingsSubstitutionsRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/_settings/support-access': {
      id: '/_app/_settings/support-access'
      path: '/support-access'
      fullPath: '/support-access'
      preLoaderRoute: typeof AppSettingsSupportAccessRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/_settings/users': {
      id: '/_app/_settings/users'
      path: '/users'
      fullPath: '/users'
      preLoaderRoute: typeof AppSettingsUsersRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/ops/alerts': {
      id: '/_app/ops/alerts'
      path: '/ops/alerts'
      fullPath: '/ops/alerts'
      preLoaderRoute: typeof AppOpsAlertsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/ops/backups': {
      id: '/_app/ops/backups'
      path: '/ops/backups'
      fullPath: '/ops/backups'
      preLoaderRoute: typeof AppOpsBackupsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/ops/jobs': {
      id: '/_app/ops/jobs'
      path: '/ops/jobs'
      fullPath: '/ops/jobs'
      preLoaderRoute: typeof AppOpsJobsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/ops/log': {
      id: '/_app/ops/log'
      path: '/ops/log'
      fullPath: '/ops/log'
      preLoaderRoute: typeof AppOpsLogRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/protocols/$id': {
      id: '/_app/protocols/$id'
      path: '/protocols/$id'
      fullPath: '/protocols/$id'
      preLoaderRoute: typeof AppProtocolsIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/_settings/audit_/exports': {
      id: '/_app/_settings/audit_/exports'
      path: '/audit/exports'
      fullPath: '/audit/exports'
      preLoaderRoute: typeof AppSettingsAuditExportsRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/_settings/ops/deployments': {
      id: '/_app/_settings/ops/deployments'
      path: '/ops/deployments'
      fullPath: '/ops/deployments'
      preLoaderRoute: typeof AppSettingsOpsDeploymentsRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/_settings/ops/status': {
      id: '/_app/_settings/ops/status'
      path: '/ops/status'
      fullPath: '/ops/status'
      preLoaderRoute: typeof AppSettingsOpsStatusRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/_settings/settings/': {
      id: '/_app/_settings/settings/'
      path: '/settings'
      fullPath: '/settings/'
      preLoaderRoute: typeof AppSettingsSettingsIndexRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/_settings/settings/company': {
      id: '/_app/_settings/settings/company'
      path: '/settings/company'
      fullPath: '/settings/company'
      preLoaderRoute: typeof AppSettingsSettingsCompanyRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/_settings/settings/directory': {
      id: '/_app/_settings/settings/directory'
      path: '/settings/directory'
      fullPath: '/settings/directory'
      preLoaderRoute: typeof AppSettingsSettingsDirectoryRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/_settings/settings/letters': {
      id: '/_app/_settings/settings/letters'
      path: '/settings/letters'
      fullPath: '/settings/letters'
      preLoaderRoute: typeof AppSettingsSettingsLettersRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/_settings/settings/mail': {
      id: '/_app/_settings/settings/mail'
      path: '/settings/mail'
      fullPath: '/settings/mail'
      preLoaderRoute: typeof AppSettingsSettingsMailRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/_settings/settings/mailing': {
      id: '/_app/_settings/settings/mailing'
      path: '/settings/mailing'
      fullPath: '/settings/mailing'
      preLoaderRoute: typeof AppSettingsSettingsMailingRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/_settings/settings/password': {
      id: '/_app/_settings/settings/password'
      path: '/settings/password'
      fullPath: '/settings/password'
      preLoaderRoute: typeof AppSettingsSettingsPasswordRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/_settings/settings/protocols': {
      id: '/_app/_settings/settings/protocols'
      path: '/settings/protocols'
      fullPath: '/settings/protocols'
      preLoaderRoute: typeof AppSettingsSettingsProtocolsRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/_settings/settings/sessions': {
      id: '/_app/_settings/settings/sessions'
      path: '/settings/sessions'
      fullPath: '/settings/sessions'
      preLoaderRoute: typeof AppSettingsSettingsSessionsRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/_settings/settings/shortcuts': {
      id: '/_app/_settings/settings/shortcuts'
      path: '/settings/shortcuts'
      fullPath: '/settings/shortcuts'
      preLoaderRoute: typeof AppSettingsSettingsShortcutsRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/_settings/settings/view': {
      id: '/_app/_settings/settings/view'
      path: '/settings/view'
      fullPath: '/settings/view'
      preLoaderRoute: typeof AppSettingsSettingsViewRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/_settings/users/$id': {
      id: '/_app/_settings/users/$id'
      path: '/$id'
      fullPath: '/users/$id'
      preLoaderRoute: typeof AppSettingsUsersIdRouteImport
      parentRoute: typeof AppSettingsUsersRoute
    }
    '/_app/_settings/settings/protocols_/new': {
      id: '/_app/_settings/settings/protocols_/new'
      path: '/settings/protocols/new'
      fullPath: '/settings/protocols/new'
      preLoaderRoute: typeof AppSettingsSettingsProtocolsNewRouteImport
      parentRoute: typeof AppSettingsRoute
    }
  }
}

interface AppSettingsUsersRouteChildren {
  AppSettingsUsersIdRoute: typeof AppSettingsUsersIdRoute
}

const AppSettingsUsersRouteChildren: AppSettingsUsersRouteChildren = {
  AppSettingsUsersIdRoute: AppSettingsUsersIdRoute,
}

const AppSettingsUsersRouteWithChildren =
  AppSettingsUsersRoute._addFileChildren(AppSettingsUsersRouteChildren)

interface AppSettingsRouteChildren {
  AppSettingsAgentKeysRoute: typeof AppSettingsAgentKeysRoute
  AppSettingsAuditRoute: typeof AppSettingsAuditRoute
  AppSettingsProfileRoute: typeof AppSettingsProfileRoute
  AppSettingsRightsRoute: typeof AppSettingsRightsRoute
  AppSettingsSubstitutionsRoute: typeof AppSettingsSubstitutionsRoute
  AppSettingsSupportAccessRoute: typeof AppSettingsSupportAccessRoute
  AppSettingsUsersRoute: typeof AppSettingsUsersRouteWithChildren
  AppSettingsAuditExportsRoute: typeof AppSettingsAuditExportsRoute
  AppSettingsOpsDeploymentsRoute: typeof AppSettingsOpsDeploymentsRoute
  AppSettingsOpsStatusRoute: typeof AppSettingsOpsStatusRoute
  AppSettingsSettingsCompanyRoute: typeof AppSettingsSettingsCompanyRoute
  AppSettingsSettingsDirectoryRoute: typeof AppSettingsSettingsDirectoryRoute
  AppSettingsSettingsLettersRoute: typeof AppSettingsSettingsLettersRoute
  AppSettingsSettingsMailRoute: typeof AppSettingsSettingsMailRoute
  AppSettingsSettingsMailingRoute: typeof AppSettingsSettingsMailingRoute
  AppSettingsSettingsPasswordRoute: typeof AppSettingsSettingsPasswordRoute
  AppSettingsSettingsProtocolsRoute: typeof AppSettingsSettingsProtocolsRoute
  AppSettingsSettingsSessionsRoute: typeof AppSettingsSettingsSessionsRoute
  AppSettingsSettingsShortcutsRoute: typeof AppSettingsSettingsShortcutsRoute
  AppSettingsSettingsViewRoute: typeof AppSettingsSettingsViewRoute
  AppSettingsSettingsIndexRoute: typeof AppSettingsSettingsIndexRoute
  AppSettingsSettingsProtocolsNewRoute: typeof AppSettingsSettingsProtocolsNewRoute
}

const AppSettingsRouteChildren: AppSettingsRouteChildren = {
  AppSettingsAgentKeysRoute: AppSettingsAgentKeysRoute,
  AppSettingsAuditRoute: AppSettingsAuditRoute,
  AppSettingsProfileRoute: AppSettingsProfileRoute,
  AppSettingsRightsRoute: AppSettingsRightsRoute,
  AppSettingsSubstitutionsRoute: AppSettingsSubstitutionsRoute,
  AppSettingsSupportAccessRoute: AppSettingsSupportAccessRoute,
  AppSettingsUsersRoute: AppSettingsUsersRouteWithChildren,
  AppSettingsAuditExportsRoute: AppSettingsAuditExportsRoute,
  AppSettingsOpsDeploymentsRoute: AppSettingsOpsDeploymentsRoute,
  AppSettingsOpsStatusRoute: AppSettingsOpsStatusRoute,
  AppSettingsSettingsCompanyRoute: AppSettingsSettingsCompanyRoute,
  AppSettingsSettingsDirectoryRoute: AppSettingsSettingsDirectoryRoute,
  AppSettingsSettingsLettersRoute: AppSettingsSettingsLettersRoute,
  AppSettingsSettingsMailRoute: AppSettingsSettingsMailRoute,
  AppSettingsSettingsMailingRoute: AppSettingsSettingsMailingRoute,
  AppSettingsSettingsPasswordRoute: AppSettingsSettingsPasswordRoute,
  AppSettingsSettingsProtocolsRoute: AppSettingsSettingsProtocolsRoute,
  AppSettingsSettingsSessionsRoute: AppSettingsSettingsSessionsRoute,
  AppSettingsSettingsShortcutsRoute: AppSettingsSettingsShortcutsRoute,
  AppSettingsSettingsViewRoute: AppSettingsSettingsViewRoute,
  AppSettingsSettingsIndexRoute: AppSettingsSettingsIndexRoute,
  AppSettingsSettingsProtocolsNewRoute: AppSettingsSettingsProtocolsNewRoute,
}

const AppSettingsRouteWithChildren = AppSettingsRoute._addFileChildren(
  AppSettingsRouteChildren,
)

interface AppRouteChildren {
  App403Route: typeof App403Route
  AppSettingsRoute: typeof AppSettingsRouteWithChildren
  AppControlRoute: typeof AppControlRoute
  AppDirectoryRoute: typeof AppDirectoryRoute
  AppDocumentsRoute: typeof AppDocumentsRoute
  AppInboxRoute: typeof AppInboxRoute
  AppMyRoute: typeof AppMyRoute
  AppSearchRoute: typeof AppSearchRoute
  AppTeamRoute: typeof AppTeamRoute
  AppIndexRoute: typeof AppIndexRoute
  AppOpsAlertsRoute: typeof AppOpsAlertsRoute
  AppOpsBackupsRoute: typeof AppOpsBackupsRoute
  AppOpsJobsRoute: typeof AppOpsJobsRoute
  AppOpsLogRoute: typeof AppOpsLogRoute
  AppProtocolsIdRoute: typeof AppProtocolsIdRoute
}

const AppRouteChildren: AppRouteChildren = {
  App403Route: App403Route,
  AppSettingsRoute: AppSettingsRouteWithChildren,
  AppControlRoute: AppControlRoute,
  AppDirectoryRoute: AppDirectoryRoute,
  AppDocumentsRoute: AppDocumentsRoute,
  AppInboxRoute: AppInboxRoute,
  AppMyRoute: AppMyRoute,
  AppSearchRoute: AppSearchRoute,
  AppTeamRoute: AppTeamRoute,
  AppIndexRoute: AppIndexRoute,
  AppOpsAlertsRoute: AppOpsAlertsRoute,
  AppOpsBackupsRoute: AppOpsBackupsRoute,
  AppOpsJobsRoute: AppOpsJobsRoute,
  AppOpsLogRoute: AppOpsLogRoute,
  AppProtocolsIdRoute: AppProtocolsIdRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AppRoute: AppRouteWithChildren,
  ForgotPasswordRoute: ForgotPasswordRoute,
  LoginRoute: LoginRoute,
  EnterTokenRoute: EnterTokenRoute,
  HelpAssigneeRoute: HelpAssigneeRoute,
  InviteTokenRoute: InviteTokenRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
